import React, { FunctionComponent, useEffect, useState } from "react"

interface iInputProps {
  name: string
  label?: string
  type?: "text" | "checkbox" | "number"
  placeholder?: string
  onChange?: (value: string | number | boolean) => void
  value?: string | number
  containerClassName?: string
}

const Input: FunctionComponent<iInputProps> = ({
  name,
  label = "",
  placeholder,
  type = "text",
  value = "",
  onChange,
  containerClassName = "",
}) => {
  const [_value, setValue] = useState(value)

  useEffect(() => {
    setValue(value)
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value
    switch (type) {
      case "checkbox":
        value = e.target.checked
        break
      case "number":
        value = e.target.valueAsNumber
        break
      default:
        value = e.target.value
        break
    }
    onChange && onChange(value)
    setValue(e.target.value)
  }

  return (
    <div
      className={`form-group ${
        type === "checkbox" ? "checkbox-wrap" : ""
      } ${containerClassName}`}
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div className="form-control">
        <input
          id={name}
          type={type}
          name={name}
          placeholder={placeholder}
          autoComplete="off"
          value={_value}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

export default Input
